import { useRef, useEffect, useState } from 'react';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

const DroppableInput =( {newMessage, typingHandler} )=> {
    function getMessageContent(data) {
        // If data is an array, find the object with type 'message'
        if (Array.isArray(data)) {
            const messageData = data.find(item => item.type === 'message');
            console.log("messageData = ", messageData);
            return messageData ? messageData.content : null;
        }
        // If data is a single object, check its type
        if (typeof data === 'object' && data !== null && data.type === 'message') {
            return data.content;
        }
        return null;
    }
    const inputRef = useRef(null);
    const [isDraggedOver, setIsDraggedOver] = useState(false);
    const handleDropAction = (data) => {
        const content = getMessageContent(data);
        if (content) {
            typingHandler(content);
        }
        setIsDraggedOver(false);
    };
    useEffect(() => {
        const el = inputRef.current;
        if (!el) return;
        const handleManualDrop = (content) => {
            typingHandler(content);
            setIsDraggedOver(false);
        };
        el._manualDropHandler = handleManualDrop;

        const cleanupDropTarget = dropTargetForElements({
            element: el,
            onDragEnter: ({ source }) => {
                const messageContent = getMessageContent(source.data);
                if (messageContent) {
                    setIsDraggedOver(true);
                }
            },
            onDragLeave: () => setIsDraggedOver(false),
            onDrop: ({ source }) => {
                const content = getMessageContent(source.data);
                if (content) {
                    typingHandler(content); 
                }
                setIsDraggedOver(false);
            },
        });

        return () => {
            cleanupDropTarget();
            delete el._manualDropHandler; 
        };
    }, [typingHandler]); 

    return (
            <input
                ref={inputRef}
                type="text"
                className='updateInput'
                id = "Encrypted"
                placeholder="Drop here an encrypted message"
                value={newMessage}
                onChange={(e)=>typingHandler(e.target.value )}
                style={{ backgroundColor: isDraggedOver ? 'rgb(190, 227, 248)' : 'initial' }}
            />
    );
}
export default DroppableInput;